





define(['./reachableRange'], function(reachableRangeModel) {
    'use strict';

    return function(data) {
        if (!Array.isArray(data.batchItems)) {
            return null;
        }
        return data.batchItems.map(function(batchItem) {
            if (batchItem.response.error) {
                return { error: batchItem.response.error};
            } else {
                return reachableRangeModel(batchItem.response);
            }
        });
    };
});



// WEBPACK FOOTER //
// ./model/routing/batchReachableRange.js